module.exports = __webpack_public_path__ + "img/lock-open-red.77a028de.svg";